import { render, staticRenderFns } from "./ImportedActivityStats.vue?vue&type=template&id=5493f4fa&scoped=true&"
import script from "./ImportedActivityStats.vue?vue&type=script&lang=ts&"
export * from "./ImportedActivityStats.vue?vue&type=script&lang=ts&"
import style0 from "./ImportedActivityStats.vue?vue&type=style&index=0&id=5493f4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5493f4fa",
  null
  
)

export default component.exports